<template>
  <form v-if="!registered" class="register-form" v-on:submit.prevent>
    <Title>{{ $t('signup.title') }}</Title>
    <slot name="personalDetails"></slot>
    <section>
      <div class="register-pw-q-wrapper">
        <p class="reg-pwd-q">{{ $t('signup.password_question') }}</p>
        <button
          type="button"
          @click="reducer({ event: 'togglePassword', payload: null })"
          :data-toggle="toggle ? 'right' : 'left'"
          :data-lang="lang"
          class="toggle-pw"
        >
          <span class="yes">{{ $t('signup.toggle_yes') }}</span>
          <span class="no">{{ $t('signup.toggle_no') }}</span>
          <div class="circle-wrapper">
            <div class="circle" />
          </div>
        </button>
      </div>
      <p class="register-pw-details">
        <span
          ><img
            alt="Info Icon"
            class="info-image"
            src="~@/assets/registerPage/info-icon.svg"
        /></span>
        {{ $t('signup.password_info') }}
      </p>
      <slot name="passwords"></slot>
    </section>
    <p class="reg-terms">
      <span>
        <input
          type="checkbox"
          class="checkbox"
          :checked="conditions"
          @click="$emit('checkbox', { event: 'checkbox', payload: conditions })"
        />
      </span>
      {{ $t('signup.accept') }}
      <router-link class="register-link" :to="{ path: 'terms' }">
        {{ $t('signup.terms') }}</router-link
      >
      {{ $t('signup.and') }}
      <router-link class="register-link" :to="{ path: 'privacy' }">
        {{ $t('signup.privacy_policy') }}</router-link
      >
    </p>

    <button
      @click="reducer({ event: 'submit', payload: null })"
      class="registration-btn-send"
      :disabled="!conditions"
    >
      {{ $t('signup.button') }}
    </button>
    <div v-if="errorMessage" class="form-error">
      {{ errorMessage }}
    </div>
    <AdaptiveSpace :adaptiveHeight="['10vh', '0vh']" />
  </form>
</template>

<script>
import Title from './Title.vue';
import AdaptiveSpace from './AdaptiveSpace.vue';
import { getLangFromRoute } from '../../shared/languageHelpers';

export default {
  name: 'Form',
  props: [
    'registered',
    'conditions',
    'togglePw',
    'toggle',
    'reducer',
    'errorMessage',
  ],
  components: { Title, AdaptiveSpace },
  data() {
    return { lang: 'de' };
  },
  created() {
    this.lang = getLangFromRoute(this.$route.path);
  },
};
</script>

<style scoped>
.register-form {
  --mail-icon-height: 110px;
  --download-image-width: 40vw;
  --register-form-p: 50px;
  --fin-text-padding: 0.5em;
  padding-top: var(--register-form-p);
  max-width: 450px;
  width: 80%;
  height: 100%;
}
.reg-pwd-q {
  color: #2b4047;
  font-size: 16px;
}
.register-pw-details {
  font-size: 12px;
  color: #5e7177;
  padding-bottom: 1em;
}
.reg-terms {
  color: #2b4047;
  margin-bottom: 1em;
  margin-top: 1em;
}
.registration-btn-send {
  color: #2b4047;
  background: #ffdf22;
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 30px;
  width: 100%;
  height: 42px;
  opacity: 1;
}
.registration-btn-send:disabled {
  opacity: 0.5;
}
.register-link {
  text-decoration: underline;
}
/* FINISHED */
.reg-finished {
  text-align: center;
}
.reg-fin-text-top {
  color: #2b4047;
  font-size: 16px;
}
.reg-fin-text-bottom,
.reg-fin-email {
  padding-top: var(--fin-text-padding);
  color: #2b4047;
  font-size: 16px;
}
.reg-fin-img {
  margin: 0 auto;
  height: var(--mail-icon-height);
}
.reg-fin-email {
  font-weight: bold;
  font-size: 18px;
}
.reg-finished-title {
  color: #2b4047;
  font-size: 30px;
  font-weight: bold;
}
.reg-fin-resend {
  color: #5e7177;
  font-size: 16px;
  border: 2px solid #5e7177;
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 30px;
  height: 42px;
  width: 165px;
}

.reg-flex {
  display: flex;
}
.reg-fin-atag {
  margin-right: 30px;
}

.register-pw-q-wrapper {
  display: flex;
  justify-content: space-between;
  padding-bottom: 1em;
}
.info-image {
  display: inline;
}
/* pw container */

.pw-container {
  opacity: 0;
  max-height: 0px;
  transition: max-height 0.3s ease-in-out, opacity 0.1s linear 0.06s;
  visibility: hidden;
}
.pw-container[data-open='true'] {
  max-height: 200px;
  opacity: 1;
  visibility: visible;
  transition: max-height 0.25s ease-in-out, opacity 0.1s linear 0.1s;
}
/* Circle */
.toggle-pw {
  border: 1px solid var(--chip-border-color);
  border-radius: 30px;
  height: 24px;
  width: 60px;
  padding: 0 2px;
  position: relative;
  overflow: hidden;
  background: var(--chip-bg);
  outline: 0;

  --circle-bg: #ffffff;
  --chip-bg: #8ad19e;
  --chip-border-color: #8ad19e;
  --chip-text-color: #ffffff;
}
.yes,
.no {
  position: absolute;
  font-size: 14px;
  transition: opacity 0.15s linear;
}
.no {
  top: 0px;
  right: 5px;
  color: #a1b1b5;
}
.yes {
  top: 0px;
  left: 5px;
  color: white;
}

.toggle-pw[data-toggle='right'] .circle-wrapper {
  transform: translateX(calc(100% - 20px));
}
.toggle-pw[data-toggle='right'] .no {
  opacity: 0;
}
.toggle-pw[data-toggle='left'] .yes {
  opacity: 0;
}
.toggle-pw[data-lang='de'] {
  width: 80px;
}
.circle-wrapper {
  width: 100%;
  transition: transform 0.25s linear;
}
.circle {
  width: 20px;
  height: 20px;
  background: var(--circle-bg);
  border-radius: 50%;
  transition: background 0.15s linear;
}
.toggle-pw[data-toggle='left'] {
  --circle-bg: #5e7177;
  --chip-border-color: #5e7177;
  --chip-bg: #ffffff;
}

.complete-subtitle {
  padding-bottom: 0.8em;
}
.complete-download-image {
  max-width: var(--download-image-width);
}

/* form-error */

.form-error {
  margin-top: 0.6em;
  position: relative;
  border: 1px solid #f15c5e;
  padding: 1em 2em;
  border-radius: 12px;
  color: #f15c5e;
}
.form-error::before {
  content: '';
  position: absolute;
  border-radius: 12px;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  width: 100%;
  height: 100%;
  background: #f15c5e;
  opacity: 0.1;
}

@media (min-width: 345px) {
  .toggle-pw[data-lang='de'] {
    width: 65px;
  }
}
@media (min-width: 376px) {
  .toggle-pw[data-lang='de'] {
    width: 60px;
  }
}
</style>
